import {useUser} from '@lore/auth';
import React, { useState } from 'react';
import { PencilSquareIcon, XMarkIcon } from '@heroicons/react/24/outline';
import Loader from '@/components/Loader'
import useTags from '@/hooks/useTags';
import TagTypes from '@/constants/TagTypes';
import useUserTags from '@/hooks/useUserTags';
import Experiences from '../../setup/experience/Experiences';

export default function EditableExperiences() {
  const currentUser = useUser();

  const [isEditing, setIsEditing] = useState(false);
  const experiences = useTags(TagTypes.Experience);
  const userExperiences = useUserTags(currentUser, TagTypes.Experience);

  if (!currentUser || experiences.state === 'FETCHING' || userExperiences.state === 'FETCHING') {
    return <Loader />;
  }

  return (
    <div>
      <div className="mb-2 flex items-start space-x-3">
        <h4 className="text-base font-semibold text-cs-gray-900">
          Tell us about any life experiences you would like to share with learners
        </h4>
        {/*<pre>{JSON.stringify(userExperiences, null, 2)}</pre>*/}
        <button
          type="button"
          className="text-cs-blue-500 hover:opacity-60"
          onClick={() => setIsEditing(!isEditing)}
          aria-label={isEditing ? 'Close edit experiences' : 'Edit experiences'}
        >
          {isEditing ? (
            <XMarkIcon className="size-5" />
          ) : (
            <PencilSquareIcon className="mt-1 size-5 shrink-0" />
          )}
        </button>
      </div>
      {isEditing ? (
        <div className="mt-4">
          <Experiences
            user={currentUser}
            experiences={experiences}
            userExperiences={userExperiences}
          />
        </div>
      ) : (
        <div className="space-y-2 text-base text-cs-gray-500">
          {userExperiences.data.length > 0 ? (
            userExperiences.data.map((ue) => (
              <div key={ue.id}>
                <div>{ue.data.name}</div>
                <div className="text-xs pl-4">{ue._tagNode.data.description}</div>
              </div>
            ))
          ) : (
            <p className="italic text-cs-gray-400">No experiences shared yet.</p>
          )}
        </div>
      )}
    </div>
  );
}
